module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURZqrwP///0xpcZqqwJqqwJmpwJ2sv5mpv+aVrWEAAAAHdFJOU50BAIbv0zTxCjISAAAAjklEQVQoz3VSQQ6AMAjrTl4Xf+DeYOIDPPgDfYF3EzV8X+MsJjTuQAiUUmBYx7b46/oZi6UvkO3EZJtDusYODPZBstmO2xByAyzhsQ7YWhSH1BSKQ2oGdJiAe28cxLISZCM3SEdqsCGbg5IoDy76HeAnEEuENLYVYVG6DBfHlwXFFcqS5QxyKDmlHDt+hwsIfmpj0s1nfwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/icon-close.png
// module id = 624
// module chunks = 0